<div #container class="container-table-addresses">
  <form>
    <table-pro [configs]="tableConfig">
      <div top-action-1>
        <button class="btn btn-primary w-100 btn-sm" (click)="showNewAddressForm()">
          <span class="material-symbols-outlined d-flex m-r-4"> add </span>

          {{ 'checkoutAddress.addNewAddress' | cxTranslate }}
        </button>
      </div>

      <table class="table-responsive table-md">
        <thead>
          <tr>
            <th class="flex-col-actions"></th>
            <th>{{ 'checkoutAddress.company' | cxTranslate }}</th>
            <th>{{ 'checkoutAddress.street' | cxTranslate }}</th>
            <th>{{ 'checkoutAddress.city' | cxTranslate }}</th>
            <th>{{ 'checkoutAddress.state' | cxTranslate }}</th>
            <th>{{ 'checkoutAddress.postalCode' | cxTranslate }}</th>
            <th>{{ 'checkoutAddress.country' | cxTranslate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let card of addressCards" class="c-pointer" (click)="setAddress(card)">
            <td class="flex-col-actions" [attr.data-value]="card.address.id === currentCard?.address?.id">
              <div class="form-group">
                <label for>
                  <div class="form-check">
                    <input
                      id="shipping-address-{{ card.address.id }}"
                      class="form-check-input"
                      role="radio"
                      type="radio"
                      aria-checked="true"
                      [value]="card.address.id"
                      name="shipping-address"
                      [checked]="card.address.id === currentCard?.address?.id"
                    />
                  </div>
                </label>
              </div>
            </td>

            <td>
              <span class="responsive-title">{{ 'checkoutAddress.company' | cxTranslate }}: </span>

              {{ card.address.companyName }}
            </td>

            <td>
              <span class="responsive-title">{{ 'checkoutAddress.street' | cxTranslate }}: </span>

              {{ card.address.line1 }}
            </td>

            <td>
              <span class="responsive-title">{{ 'checkoutAddress.city' | cxTranslate }}: </span>

              {{ card.address.town }}
            </td>

            <td>
              <span class="responsive-title">{{ 'checkoutAddress.state' | cxTranslate }}: </span>

              {{ card.address.region?.name }}
            </td>

            <td>
              <span class="responsive-title">{{ 'checkoutAddress.postalCode' | cxTranslate }}: </span>

              {{ card.address.postalCode }}
            </td>

            <td>
              <span class="responsive-title">{{ 'checkoutAddress.country' | cxTranslate }}: </span>

              {{ card.address.country?.name }}
            </td>

            <td class="flex-col-address-type" [attr.data-value]="card.address.dropShippingAddress ? 'd' : 's'">
              <div class="item">
                <span class="responsive-title m-r-4">{{ 'checkoutAddress.type' | cxTranslate }}: </span>

                <address-type-icon [address]="card.address"></address-type-icon>
              </div>

              <div class="d-flex d-lg-none m-t-12">
                <button type="button" class="btn btn-outline-primary w-100">{{ 'checkoutAddress.setDefault' | cxTranslate }}</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </table-pro>
  </form>
</div>